webpackJsonp([75],{

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1280);


/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _fr = __webpack_require__(791);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('fr', _fr2.default);

/***/ })

},[1279]);


// WEBPACK FOOTER //
// app/datetime.fr-b30557552a1be7c3bbe9.js